import React from 'react';
import { StyleSheet, View } from 'react-native';

import { ProgressIndicatorProps } from '../Questionnaire/ProgressIndicatorSwitcher';

import CheckIcon from '@common/components/Icons/CheckIcon';
import DotIcon from '@common/components/Icons/DotIcon';

const ProgressStepper: React.FC<Omit<ProgressIndicatorProps, 'variant'>> = ({
  progress,
  total,
  styleConfig,
}) => {
  const style = createStyle(styleConfig);
  const completedColor = styleConfig?.step?.activeColor || '#0175FF';
  const backgroundColor = styleConfig?.step?.backgroundColor || '#E4EAEE';

  return (
    <View style={{ display: 'flex', flexDirection: 'row', marginRight: -16 }}>
      {Array.from(Array(total).keys()).map((item) => {
        const completed = item < progress;

        return (
          <View
            key={item}
            style={{
              position: 'relative',
            }}
          >
            <View
              key={item}
              style={[
                style.stepper,
                {
                  backgroundColor: completed ? completedColor : backgroundColor,
                },
              ]}
            >
              {completed ? (
                <CheckIcon fill={styleConfig?.color} />
              ) : (
                <DotIcon fill={styleConfig?.color} />
              )}
            </View>
            {total - 1 !== item ? <View style={style.line} /> : null}
          </View>
        );
      })}
    </View>
  );
};

const createStyle = (style: any) => {
  return StyleSheet.create({
    stepper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 32,
      width: 32,
      borderRadius: 16,
      marginRight: 16,
    },
    line: {
      position: 'absolute',
      top: '50%',
      right: 0,
      borderBottomColor: style?.line?.backgroundColor || '#E4EAEE',
      borderBottomWidth: style?.line?.borderBottomWidth || 2,
      width: 16,
    },
    icon: {
      color: style?.color,
    },
  });
};

export default ProgressStepper;
